<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" v-shortkey="['esc']" @shortkey="cerrar" variant="danger"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Registros de Desperdicios
                        </h3>
                    </div>
                    <div class="col-sm-4 mt-3">
                        <label for="" class="form-label">Fecha Inicio</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_inicio">
                    </div>
                    <div class="col-sm-4 mt-3">
                        <label for="" class="form-label">Fecha Fin</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_fin">
                    </div>
                    <div class="col-sm-4 mt-5">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="buscar_mermas">Buscar</button>
                    </div>
                    <div class="col-sm-12 mt-3 mb-3">
                        <div class="marco_listado_mermas">
                            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                                <thead>
                                    <tr>
                                        <th style="width: 15%;text-align: center;">
                                            Fecha
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Máquina
                                        </th>
                                        <th style="width: 15%;text-align: center;">
                                            Tipo Rollo
                                        </th>
                                        <th style="width: 45%;text-align: center;">
                                            Comentarios
                                        </th>
                                        <th style="width: 10%;text-align: center;">
                                            ...
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in mermas" :key="index">
                                        <td style="text-align: center;">
                                            {{ formatearFecha(item.fecha) }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ obtenerNombreMaquina(item.maquina) }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ obtenerNombreRollo(item.tipo_de_rollo) }}
                                        </td>
                                        <td style="text-align: center;">
                                            {{ item.comentarios }}
                                        </td>
                                        <td style="text-align: center;">
                                            <button type="button" style="font-size: 11px;"
                                                class="btn btn-sm btn-outline-dark"
                                                @click="abrir_modal_detalle(item)"><i class="fas fa-eye"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </b-row>
            </b-container>
        </div>

        <DetalleMerma v-if="modal_detalle" :item="item" v-on:salir="cerrar_modal_detalle" />

    </div>
</template>

<script>
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';
    import { minix } from '../functions/alertas';
    import DetalleMerma from './DetalleMermaRegistrada.vue'

    export default {
        name: 'ListadoDeMermas',
        computed: {
            ...mapState(['maquinas', 'tipos_de_rollo', 'id_empresa_seleccionada', 'datos_usuario'])
        },
        components: {
            DetalleMerma
        },
        data() {
            return {
                fecha_inicio: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                fecha_fin: moment().format('YYYY-MM-DD'),
                mermas: [],
                modal_detalle: false,
                item: {}
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            formatearFecha(fecha) {
                return moment(fecha).format('DD/MM/YYYY')
            },
            obtenerNombreMaquina(id) {
                const maquina = this.maquinas.find(m => m.id === id)
                return maquina ? maquina.nombre : '-'
            },
            obtenerNombreRollo(id) {
                const rollo = this.tipos_de_rollo.find(r => r.id === id)
                return rollo ? rollo.nombre : '-'
            },
            abrir_modal_detalle(item) {
                this.item = item
                this.modal_detalle = true
            },
            cerrar_modal_detalle() {
                this.modal_detalle = false
            },
            async buscar_mermas() {
                if (!this.fecha_inicio || !this.fecha_fin) {
                    minix({ icon: 'error', mensaje: 'Seleccione un rango de fechas', tiempo: 3000 })
                    return
                }

                try {
                    let f = {
                        api: `mermas/c/consulta-registros?fecha_inicial=${this.fecha_inicio}&fecha_final=${this.fecha_fin}&empresa=${this.id_empresa_seleccionada}`
                    }

                    const resultado = await this.obtener_data(f)
                    this.mermas = resultado || []

                    if (this.mermas.length === 0) {
                        minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 3000 })
                    }
                } catch (error) {
                    minix({ icon: 'error', mensaje: 'Error al buscar mermas', tiempo: 3000 })
                    console.error(error)
                }
            },
            ...mapActions(['obtener_data'])
        },
        mounted() {
            // Cargar datos iniciales al montar el componente
            // this.buscar_mermas()
        }
    }
</script>

<style>
    .marco_listado_mermas {
        width: 100%;
        height: 350px;
        /* border: 1px solid #e9e9e9; */
        border-radius: 4px;
        overflow: auto;
    }


</style>